<template>
    <div class="row">
        <div class="col-12 mb-1">
            Personel: <strong>{{ value.FullName }}</strong>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Tutar (TL)</label>
            <v-currency-input  input-class="text-right" :value="value.NewAmount" v-on:update-value="currencyAmount => value.NewAmount = currencyAmount"></v-currency-input>
        </div>
        <div class="col-12">
            <label class="form-label">Açıklama</label>
            <textarea class="form-control resize-none" rows="2" placeholder="Açıklama" v-model="value.Description"></textarea>
        </div>
    </div>
</template>

<script>
import VCurrencyInput from '@/components/VCurrencyInput.vue'

export default {
    components:{
        VCurrencyInput
    },
    props:{
        value:Object
    }
}
</script>